import React from 'react';
import { INK } from './constants';

export function KeyFeatures({ bullets }: { bullets: string[] }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: '16px' }}>
      <p style={{ margin: 0, fontSize: 16, fontWeight: 500, lineHeight: '20.8px', color: INK }}>Key features</p>
      <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {bullets.map((bullet, index) => (
          <li
            key={index}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 16,
              padding: '0',
              fontSize: 14,
              fontWeight: 400,
              lineHeight: '20px',
              color: INK,
            }}
          >
            <span
              aria-hidden="true"
              style={{
                flexShrink: 0,
                height: 20,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  width: 4,
                  height: 4,
                  borderRadius: '50%',
                  background: 'currentColor',
                }}
              />
            </span>
            <span style={{ flex: 1, fontSize: 14, fontWeight: 400, lineHeight: '20px' }}>{bullet}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
